export default {"src":"/_next/static/media/give-logo-text.75b7586e.svg","height":53,"width":151};